import { useTranslation } from 'react-i18next';
import useFetchAllPropertiesForPromoCodes from '../../useFetchAllPropertiesForPromoCodes';

interface PropertyNameCellProps {
  getValue: () => string | null;
}

const PropertyNameCell = ({ getValue }: PropertyNameCellProps) => {
  const { t } = useTranslation();
  const propertyUid = getValue();
  const { propertyMap } = useFetchAllPropertiesForPromoCodes();

  if (!propertyUid) {
    return t('common.all');
  }

  const property = propertyMap?.[propertyUid];

  return property?.name ?? '-';
};

export default PropertyNameCell;
